import {useEffect, useRef} from 'react'
import {useRootStore} from '@/store'
import {selectGlobalTranslateStore} from '@/store/selectors'
import {useGetTranslation} from '@/features/translation/queries/useGetTranslation'

const DEBOUNCE_DELAY = 1000

export const useTranslationBatcher = () => {
    const {
        requests,
        clearRequests,
        clearResults,
        setResults: setTranslatedResults,
        currentLanguage
    } = useRootStore(selectGlobalTranslateStore)
    const {mutateAsync: onTranslateApi} = useGetTranslation()
    const targetLanguage = requests[0]?.targetLang
    const timerRef = useRef<NodeJS.Timeout>()
    useEffect(() => {
        if (requests.length > 0) {
            clearTimeout(timerRef.current)

            timerRef.current = setTimeout(async () => {
                try {
                    const translatedBatch = await onTranslateApi({
                        target: targetLanguage,
                        contents: requests.map(req => ({id: +req.id, text: req.text}))
                    })
                    if (translatedBatch.contents) {
                        setTranslatedResults(translatedBatch.contents)
                    }
                } catch (error) {
                    console.error('Translation batch failed:', error)
                } finally {
                    clearRequests()
                }
            }, DEBOUNCE_DELAY)
        }

        return () => {
            clearTimeout(timerRef.current)
        }
    }, [requests])
    useEffect(() => {
        clearResults()
    }, [currentLanguage])
}
